var DataBehavior = require('backbone-torso/modules/behaviors/DataBehavior');
var insurancePolicyDetailsCollection = require('./insurancePolicyDetailsCollection');

/**
 * Data Behavior hooked up to the insurance policy details cache.
 * @class InsurancePolicyDetailsDataBehavior
 * @constructor
 */
module.exports = DataBehavior.extend({
  cache: insurancePolicyDetailsCollection
});
